import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface SelectionRabCorrectScorePropsType {
    variant: DefaultComponentVariantType | null;
}

const setSelectionNestedWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css``;
    }
    return css`
        border-right: 1px solid ${theme.star.selectionsGroup.borderColor};
        border-left: 1px solid ${theme.star.selectionsGroup.borderColor};
    `;
};

export const SelectionNestedWrapper = withConfig(theme => styled('div', { label: 'SelectionNestedWrapper' })<SelectionRabCorrectScorePropsType>`
    ${({ variant }): SerializedStyles => setSelectionNestedWrapper(variant, theme)}
    display: flex;
    flex-flow: column nowrap;
`);

const setSelectionRabFiltersItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium} 0;
        `;
    }
    return css`
        border-bottom: 1px solid ${theme.star.selectionsGroup.borderColor};
        border-left: 1px solid ${theme.star.selectionsGroup.borderColor};
        border-right: 1px solid ${theme.star.selectionsGroup.borderColor};
        padding: ${theme.star.padding.medium};
    `;
};

export const SelectionRabFiltersItem = withConfig(theme => styled('ul', { label: 'SelectionRabFiltersItem' })<SelectionRabCorrectScorePropsType>`
    ${({ variant }): SerializedStyles => setSelectionRabFiltersItem(variant, theme)}
    background: ${theme.star.marketGroupGoalscorer.filters.bgColor};
    display: flex;
`);

export const ThreeColumnContainer = withConfig(theme => styled('div', { label: 'ThreeColumnContainer' })<SelectionRabCorrectScorePropsType>`
    display: flex;
    padding: 0;
    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.small : '0'};
`);

const setThreeColumnItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.small};
        `;
    }
    return css``;
};

export const ThreeColumnItem = withConfig(theme => styled('ul', { label: 'ThreeColumnItem' })<SelectionRabCorrectScorePropsType>`
    ${({ variant }): SerializedStyles => setThreeColumnItem(variant, theme)}
    width: 33.333%;
    &:last-of-type {
        li {
            border-left: 1px solid ${theme.star.selectionsGroup.borderColor};
            border-right: none;
        }
    }

    &:nth-of-type(2) {
        li {
            border-left: none;
            border-right: none;
        }
    }
`);
